import produce from 'immer';
import { checkRangeValidity } from './date-picker-helper';
export const initialState = {
  range: {},
  restrictedRange: {},
  keepOpen: false,
  allowOpenRange: false,
  validity: 'Unknown',
  isFromOpen: false,
  isToOpen: false,
  fromValidity: 'Valid',
  toValidity: 'Valid'
};
const validate = draft => {
  draft.validity = checkRangeValidity(draft.range);
  if (draft.validity !== 'InvalidRange' || draft.fromValidity !== 'Valid' || draft.toValidity !== 'Valid') {
    draft.errorMessage = undefined;
  } else {
    draft.errorMessage = `date.error.${draft.validity}`;
  }
};
export const reducer = (state, action) => produce(state, draft => {
  switch (action.type) {
    case 'set-keep-open':
      draft.keepOpen = action.keepOpen;
      draft.isFromOpen = action.keepOpen;
      return draft;
    case 'set-allow-open-range':
      draft.allowOpenRange = action.allowOpenRange;
      return draft;
    case 'set-range':
      draft.range = action.range || {};
      if (draft.range.from === '') {
        draft.range.from = undefined;
      }
      if (draft.range.to === '') {
        draft.range.to = undefined;
      }
      validate(draft);
      return draft;
    case 'set-restricted-range':
      draft.restrictedRange = action.range || {};
      validate(draft);
      return draft;
    case 'set-from':
      if (draft.range.from !== action.date) {
        draft.range.from = action.date;
        validate(draft);

        // automatically open "to" picker after entering the from date
        if (draft.range.from && draft.errorMessage === undefined) {
          draft.isFromOpen = false;
          draft.isToOpen = true;

          // initialize the "to" picker with the from date
          if (!draft.range.to && !state.allowOpenRange) {
            draft.range.to = draft.range.from;
          }
        }
      }
      return draft;
    case 'set-to':
      if (draft.range.to !== action.date) {
        draft.range.to = action.date;
        validate(draft);
        if (draft.range.to && !draft.keepOpen) {
          draft.isToOpen = false;
        }
      }
      return draft;
    case 'set-from-open':
      draft.isFromOpen = action.isOpen;
      if (action.isOpen) {
        draft.isToOpen = false;
      } else if (draft.keepOpen) {
        draft.isToOpen = true;
      }
      return draft;
    case 'set-to-open':
      draft.isToOpen = action.isOpen;
      if (action.isOpen) {
        draft.isFromOpen = false;
      } else if (draft.keepOpen) {
        draft.isFromOpen = true;
      }
      return draft;
    case 'set-from-validity':
      draft.fromValidity = action.validity;
      validate(draft);
      return draft;
    case 'set-to-validity':
      draft.toValidity = action.validity;
      validate(draft);
      return draft;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
});